import { createSelector } from '@reduxjs/toolkit';
import { format } from 'date-fns';
import ru from 'date-fns/locale/ru';
import { RootState } from 'store/store';

const selectGameInfo = (state: RootState) => state.overlayV2.gameInfo;
const selectPeriod = (state: RootState) => state.overlayV2.time.period;

export const selectGoals = createSelector([selectGameInfo], (gameInfo) => gameInfo.goals);

export const selectShootoutGoals = createSelector([selectGameInfo], (gameInfo) => gameInfo.shootout.goals);

export const selectShootoutMisses = createSelector([selectGameInfo], (gameInfo) => gameInfo.shootout.misses);

export const selectOrganizer = createSelector([selectGameInfo], (gameInfo) => gameInfo.organizer);

export const selectChampionship = createSelector([selectGameInfo], (gameInfo) => gameInfo.championship);

export const selectMatch = createSelector([selectGameInfo], (gameInfo) => gameInfo.match);

export const selectTeams = createSelector([selectGameInfo], (gameInfo) => gameInfo.teams);

export const selectLoading = createSelector([selectGameInfo], (gameInfo) => ({
  isLoading: gameInfo.isLoading,
  isLoaded: gameInfo.isLoaded,
}));

export const selectSynchronization = createSelector([selectGameInfo], (gameInfo) => ({
  isSynchronization: gameInfo.isSynchronization,
  isSynchronize: gameInfo.isSynchronize,
}));

export const selectGameInfoError = createSelector([selectGameInfo], (gameInfo) => gameInfo.error);

export const selectFormatStartDate = createSelector([selectMatch], (match) => {
  const date = match?.date ? new Date(match?.date) : undefined;

  return {
    date: date ? format(date, 'd MMMM', { locale: ru }) : 'Неизвестная дата',
    time: date ? format(date, 'HH:mm') : 'Неизвестное время',
  };
});

export const selectFoulsByCurrentPeriod = createSelector(
  [selectGameInfo, selectPeriod],
  (gameInfo, period) => gameInfo.fouls[period] ?? { first: 0, second: 0 },
);
